import type { AppEnvironment } from './types';
import { IP4CMS_PAGE_COPY } from './page-copy-ip4cms';

/**
 * IP4CMS member portal (ZA). Same regional stack as ip4x; served from
 * `dist/ip4cms` on `*.ip4cms-member-za.ip4x.systems`. Per-tenant branding
 * and config come from runtime hostname → Core resolve-domain.
 *
 * Core must include `ip4cms-member-za.ip4x.systems` in BASE_DOMAINS (and TLS
 * on-demand allowlist via resolve-domain) for tenant subdomains to work.
 */
export const env: AppEnvironment = {
  production: true,
  buildMode: 'ip4cms',
  apiBaseUrl: 'https://ip4x-za.sudosky.com/v1',
  coreApiUrl: 'https://ip4x-core-api.sudosky.com/v1',
  appTemplateId: '',
  authMode: 'core',
  portalOwnerType: 'member',
  loadDomainConfig: true,
  defaultDomain: 'gloventpaas.member.ip4x.systems',
  rootTenantId: 'd1bb2a75-f0c8-4d28-9a81-c4e8a090efae',
  portalBaseUrl: 'https://ip4cms-member-za.ip4x.systems',
  appName: 'IP4CMS',
  version: '1.0.0',
  appShell: 'classic',
  keyboardShift: true,
  welcomeContent: {
    eyebrow: 'Member portal',
    title: 'Your community,\nin your pocket.',
    subtitle: 'Access and services in one place.',
  },
  communitySelectContent: {
    title: 'Choose your community',
    subtitle: 'Search for your community to continue.',
  },
  joinCommunity: {
    // Enabled at build level; the entry point still only shows when an SSO
    // root scope resolves at runtime (so there are sibling communities).
    enabled: true,
    entryLabel: 'Join a community',
    entityName: 'community',
    entityPlural: 'communities',
    title: 'Join a community',
    subtitle: 'Request access to another community.',
    searchTitle: 'Find your community',
    searchSubtitle: 'Search for the community you want to join.',
    searchPlaceholder: 'Search communities…',
    detailsTitle: 'Your details',
    detailsSubtitle: 'Confirm your details.',
    submitLabel: 'Request to join',
    termsLabel: 'I accept the terms and conditions',
    successTitle: 'Request submitted',
    successMessage:
      "Your request to join has been sent. You'll be notified once the community reviews it.",
    pendingTitle: 'Request pending',
    pendingMessage: 'You already have a pending request to join this community.',
  },
  signupTermsUrl: 'https://www.glovent.co.za/terms',
  pageCopy: IP4CMS_PAGE_COPY,
  home: {
    widgetMode: true,
    widgets: [
      { id: 'support', type: 'support', title: 'Helpdesk', order: 1, enabled: true, requiresModule: 'support' },
      { id: 'events', type: 'events', title: 'Upcoming events', order: 2, enabled: true, requiresModule: 'events' },
      { id: 'panic', type: 'panic', title: 'Emergency', order: 3, enabled: true, requiresModule: 'panic' },
      { id: 'utilities', type: 'utilities', title: 'Utilities', order: 4, enabled: true, requiresModule: 'utilities' },
    ],
  },
};
